import { combineReducers } from '@reduxjs/toolkit';
import notificationsSlice from '@modules/notifications/store';
import i18n from './i18nSlice';
import authSlice from './auth/authSlice';
import configSlice from './config/configSlice';
import routesSlice from './routes/routesSlice';
import profileSlice from './profile/profileSlice';
import Wd from './core';
// Customs imports
import modalsSlice from './modals/modalsSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    // Slices necesarios para la app
    Wd,
    i18n,
    auth: authSlice,
    config: configSlice,
    routes: routesSlice,
    profile: profileSlice,
    // Slices extras
    notifications: notificationsSlice,
    modals: modalsSlice,
    // <- Agregar aqui slices extras
    // Slices restantes de app
    ...asyncReducers,
  });

  /*
	Reset the redux store when user logged out
	 */
  if (action.type === 'user/userLoggedOut') {
    // state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
